(() => {
  const config = document.getElementById('theme-component-loader');
  if (!config) return;
  const pending = new Map();
  function load(src) {
    if (pending.has(src)) return pending.get(src);
    const existing = Array.from(document.scripts).find(script => script.src === new URL(src, document.baseURI).href);
    if (existing) return Promise.resolve();
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = () => {
        pending.delete(src);
        script.remove();
        reject(new Error('Could not load theme component'));
      };
      document.head.appendChild(script);
    });
    pending.set(src, promise);
    return promise;
  }
  function scan() {
    const quick = document.querySelector('quick-buy, quick-add');
    if (quick || document.querySelector('product-form')) {
      load(config.dataset.productFormSrc).then(() => {
        if (quick) return load(config.dataset.quickBuySrc);
      }).then(() => {
        if (customElements.get('product-form') && customElements.get('quick-buy') && customElements.get('quick-add')) observer.disconnect();
      }).catch(error => console.warn(error.message));
    }
    if (customElements.get('product-form') && customElements.get('quick-buy') && customElements.get('quick-add')) observer.disconnect();
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('product-form, quick-buy, quick-add') || node.querySelector('product-form, quick-buy, quick-add'))))) scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  scan();
})();
